import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB2tzAe8Jlihnkvxj8zj1OFhk2d_-HtUiM",
  authDomain: "priority-backend.firebaseapp.com",
  projectId: "priority-backend",
  storageBucket: "priority-backend.firebasestorage.app",
  messagingSenderId: "46209410719",
  appId: "1:46209410719:web:caa491615f58104373a4aa"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

const messaging = getMessaging(app);

export { app, db, auth, storage, messaging };
